import React, {Component} from 'react';

import Select from '../common/select'

import './styles.scss';
import ColumnChart from "./components/columnChart/ColumnsChart";
import Comment from "../common/comment/Comment";
import urls from "../../../utils/urls";
import {tokenHeader} from "../../../utils/headers";
import {ajaxHandler} from "../../../utils/errors";
import axios from "axios/index";
import _ from "lodash";
import {connect} from "react-redux";
import LoadingSpinner from "../../../components/spinner/Spinner";
import {bindActionCreators} from "redux";
import {filterCategories} from "../../../actions/navigation_actions";
import VerticalAlign from "../../../components/verticalAlign/VerticalAlign";


class ProfileFromPartnerCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: false,
            section: [],
            xhr: false,
            axiosSource: null,
        }
    }

    componentDidMount(){
        if (this.props.stations.list) {
            if (this.props.filters) {
                this.props.filterCategories(this.props.filters[this.props.filters.length - 1]);
                this.setState({selectedValue: this.props.filters[this.props.filters.length - 1], data: false}, () => {
                    this._fetchData();
                })
            }

            if (this.state.selectedValue) {
                if ((this.props.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (this.props.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (this.props.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this._fetchData();
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.stations.list){
            if (nextProps.filters) {
                this.props.filterCategories(nextProps.filters[nextProps.filters.length - 1]);
                this.setState({selectedValue: nextProps.filters[nextProps.filters.length - 1], data: false}, () => {
                    this._fetchData();
                })
            }

            if (this.state.selectedValue) {
                if ((nextProps.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (nextProps.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (nextProps.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this.setState({data: false}, this._fetchData);
                }
            }
        }

    }

    onValueChange = (ev) => {
        console.log(ev);
        this.props.filterCategories(ev.target.value);
        this.setState({selectedValue: ev.target.value}, () => {
            this._fetchData();
        })
    };


    _getColorOfCategory = (category) => {
        switch (category) {
            case "1. LOW":
                return "#DD1D21";
            case "2. MEDIUM":
                return "#FBCE07";
            case "3. HIGH":
                return "#BED50F";
            case "4. BEST":
                return "#008443";
        }
    };

    _getCategoryName = (category) =>{
        switch (category) {
            case "1. LOW":
                return "Bajo";
            case "2. MEDIUM":
                return "Medio";
            case "3. HIGH":
                return "Alto";
            case "4. BEST":
                return "Top";
        }
    }


    _getSectionName = (section) => {
        switch (section) {
            case "bbva":
                return "BBVA";
            case "single_site_loyalty":
                return "% Fiel a 1 boca";
            case "vpn_loyal":
                return "Socios 100% V-Power";
            case "age_rank":
                return "18-34 años";
            case "gender":
                return "% Masculino";

        }
    };


    getFormattedData = () => {
        let data = [];
        let membersPerLevel = [];
        let percentages = [];
        let members = 0;
        let totalMembers = 0;
        let sections = [];

        totalMembers = _.sumBy(_.filter(this.state.data.totals, (total) => {
            return total.member_category !== ''
        }), (total) => {
            return total.total
        });

        this.state.data.data.forEach((category) => {
            category.values.forEach((value) => {
                members += value.members;
            });

            percentages.push(_.round(members * 100 / totalMembers));
            members = 0;
        });


        this.state.data.categories.forEach((category) => {
            this.state.data.data.forEach((cat) => {
                sections.push(this._getSectionName(cat.field));
                let category_find = _.find(cat.values, ['member_category', category]);
                let total_find = _.find(this.state.data.totals, ['member_category', category]);
                if (category_find) {
                    data.push(category_find.members * 100 / total_find.total);
                } else {
                    data.push(0);
                }
            });
            membersPerLevel.push({name: this._getCategoryName(category), color: this._getColorOfCategory(category), data: data});
            data = []
        });

        console.log(percentages);
        return {members: membersPerLevel.reverse(), xAxis: _.uniq(sections), percentages};
    };


    _fetchData = () => {
        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});

        let user_details_url = `${urls.API_ROOT}/api/v1/penetration-info/?quarter=${this.state.selectedValue ?
            this.state.selectedValue.quarter : "Q3"}&year=${this.state.selectedValue ? this.state.selectedValue.year : "2018"}`;

        if (this.props.navigation.selectedArea !== -1) {
            user_details_url = user_details_url.concat(`&area_id=${this.props.navigation.selectedArea}`);
        }
        if (this.props.navigation.selectedZone !== -1) {
            user_details_url = user_details_url.concat(`&zone_id=${this.props.navigation.selectedZone}`);
        }
        if (this.props.navigation.selectedStation !== -1) {
            user_details_url = user_details_url.concat(`&global_code=${this.props.navigation.selectedStation}`);
        }
        axios
            .get(user_details_url, {...tokenHeader(), cancelToken: source.token})
            .then((response) => {console.log("RESPONSE", response);this.setState({data: response.data, xhr: false, axiosSource: null})})
            .catch(ajaxHandler);
    };


    render() {
        const values = this.props.filters;

        let data = this.state.data ? this.getFormattedData() : false;
        return (
            <div className={'profile-section container'}>

                <div className={"select-category"}>
                    <Select className={"select"} values={values} selectedValue={this.state.selectedValue}
                            onValueChange={this.onValueChange}/>
                </div>
                {data &&
                <div>
                    <div className={"subtitle-select"}>
                        <div className={"subtitle"}>Perfil de cada categoría de socio</div>
                    </div>
                    <div className={"column-chart"}>
                        <ColumnChart data={data.members} sections={data.xAxis}/>
                        <div className={"percentages"}>
                            {data.percentages.map((percentage,i) => {
                                return <Comment width={60}
                                                key={i}> {isNaN(percentage) ? ' - ' : percentage} %</Comment>
                            })}
                        </div>
                    </div>
                </div>}
                {!data &&
                <VerticalAlign>
                    <LoadingSpinner className={'spinner'} width={50}/>
                </VerticalAlign>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        filters: state.filters,
        navigation: state.navigation,
        stations: state.stations
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({filterCategories}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileFromPartnerCategory);



// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/profileFromPartnerCategory/ProfileFromPartnerCategory.js